import withValueHOC from "@client/hocs/withValue";
import TextInputCommon, { type TextInputAutoComplete, type TextInputProps } from "@common/controls/Inputs/Text/component";
import * as React from "react";

import "./style.less";

export { type TextInputAutoComplete, type TextInputProps };

const TextInput = ({ preventSubmit, ...props }: TextInputProps) => (
  <TextInputCommon {...props} preventSubmit={preventSubmit ?? true} />
);
export default withValueHOC<string, TextInputProps>(TextInput);
